import readRequiredNumberEnv from './services/readRequiredNumberEnv';

const expireTime = readRequiredNumberEnv(
  process.env.NEXT_PUBLIC_EXPIRE_TIME,
  'NEXT_PUBLIC_EXPIRE_TIME'
);
export default expireTime;
